// eslint-disable-next-line no-restricted-imports
import {toggle} from 'opticks'

/**
 * Hook that provides access to the opticks toggle function.
 * This hook is required to use toggle functionality instead of importing directly.
 * @returns The toggle function from opticks
 */
export const useToggle = () => {
  return toggle
}
